import { FormText } from '../FormFields/FormText'
import { useAppSelector } from '../../store/hooks'
import { FormSelect } from '../FormFields/FormSelect'
import {
  AccountInterface,
  BusinessUnitInterface,
  DeliveryEnum,
  DestinationInterface,
  FavoriteDestinationsInterfase,
  LocationInterface,
  TaxIdentificationTypeInterface,
} from '../../interfaces'
import { useContractDestinationBUs } from '../../hooks/useContractDestinationBUs'
import { resolveDestinationBusinessUnits } from '../../utils/destinationBusinessUnits'
import { FormTextArea } from '../FormFields/FormTextArea'
import { FormikErrors, FormikProps, FormikTouched } from 'formik'
import { AccountSearchFavoriteHistoric } from '../Account/AccountSearch'
import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  filterBusinessUnit,
  filterGeneral,
  filterCity,
} from '../../utils/filters'
import {
  BusinessUnitOption,
  CityOption,
  GenericoOption,
} from '../FormFields/FormSearchOptions'
import { FormSearch } from '../FormFields/FormSearch'
import { FormRadioGroup } from '../FormFields/FormRadioGroup'
import { AddressSearch } from '../FormFields/AddressSearch'
import { AutocompleteRegion } from '../FormFields/FormMaps'
import { GeneralTypePhoneServices } from '../../services/GeneralServices'
import { GeneralTypeInterface } from '../../interfaces/Dto/GeneralTypeInterface'
import { getAllFavoriteDestinations } from '../../services/FavDestinationsServices'
import { ConfirmModalStatus } from '../Preshipment/ModalSuccess'
import { ModalLoading } from '../Atoms/ModalLoading'
import { obtenerCodigoArea, obtenerNumero } from '../../utils/format'
import { getBusinessUnitByTerritory } from '../../services'

export interface FavoriteDestinationFormValues {
  abbreviationName: TaxIdentificationTypeInterface
  identificationNumber: string
  fullName: string
  codePhoneNumber?: string
  phoneId?: string
  phoneTypeId: string
  phoneNumber: string
  acceptsSMS: boolean
  codecellNumber?: string
  cellPhoneNumber: string
  emailId?: string
  email: string
  locationId?: string
  city: string
  cityCode?: string
  postalCode: string
  addressId?: string
  address: string
  businessUnit?: BusinessUnitInterface
  accountSelected?: AccountInterface
  ShipmentType?: DeliveryEnum
  reference: string
  reset?: boolean
  id?: string
  favoriteId?: string
  displayName: string
}

interface FavoriteDestinationFormField {
  consignee: FavoriteDestinationFormValues
  shippingLocation?: LocationInterface
}
interface ConsigneeFormPropsV2<T> {
  formik: FormikProps<T & FavoriteDestinationFormField>
}

export const FavoriteDestinationForm = <T extends any>({
  formik,
}: ConsigneeFormPropsV2<T>) => {
  const cities = useAppSelector((state) => state.inmutable.cities)
  const businessUnits = useAppSelector((state) => state.inmutable.businessUnits)
  const identificationTypes = useAppSelector(
    (state) => state.inmutable.taxIdentificationTypes
  )

  const clientId = useAppSelector((state) => state.user.client?.id)

  const user = useAppSelector((state) => state.user)!

  const errors = formik.errors.consignee as
    | FormikErrors<FavoriteDestinationFormValues>
    | undefined

  const touched = formik.touched.consignee as
    | FormikTouched<FavoriteDestinationFormValues>
    | undefined

  const [phonePreSearch, setPhonePreSearch] = useState('')
  const [businessUnitSearch, setBusinessUnitSearch] = useState('')
  const [citySearch, setCitySearch] = useState('')

  const [titleShipment] = useState('Oficina que entrega')

  const [favoriteList, setFavoriteList] = useState<DestinationInterface[]>([])
  const [historicList, setHistoricList] = useState<DestinationInterface[]>([])
  const [selectDestination, setselectDestination] = useState<boolean>(false)
  const [phonePrefixList, setPhonePrefixList] = useState<string[]>([])
  const [disabledIdentification, setDisabledIdentification] =
    useState<boolean>(false)
  const stores = useAppSelector((state) => state.inmutable.businessUnits)

  let [loading, setLoading] = useState(false)

  let [loadingStatus, setLoadingStatus] = useState(
    ConfirmModalStatus.PROCESSING
  )
  let [loadingTitle, setLoadingTitle] = useState('Cargando...')

  const updatePhoneSearch = useCallback(() => {
    if (!!formik.values.consignee.codePhoneNumber) {
      setPhonePreSearch(formik.values.consignee.codePhoneNumber)
    } else {
      setPhonePreSearch('')
    }
  }, [formik.values.consignee.codePhoneNumber])

  const [favDestination, setfavoriteDestination] =
    useState<FavoriteDestinationsInterfase>()

  useEffect(() => {
    const accountID = '' + user?.client?.id
    if (!accountID) return
    if (!formik.values.consignee.favoriteId) return

    const fetchShipments = async () => {
      setLoadingStatus(ConfirmModalStatus.PROCESSING)
      setLoadingTitle('Cargando...')
      setLoading(true)

      const favoriteDestination = await getAllFavoriteDestinations(
        accountID,
        formik.values.consignee.favoriteId
      )
      var listfavoriteDestination =
        favoriteDestination?.model as FavoriteDestinationsInterfase[]
      if (!favoriteDestination?.didError) {
        setfavoriteDestination(listfavoriteDestination[0])
        let client = listfavoriteDestination[0]
        setselectDestination(true)
        setDisabledIdentification(true)

        formik.setValues({
          ...formik.values,
          consignee: {
            ...formik.values.consignee,
            id: client.accountDestinationID,
            abbreviationName: identificationTypes.find(
              (t) => t.abbreviationName === client?.taxIDentificationTypeCode
            )!,
            identificationNumber: client.identificationNumber,
            address: client.addressLine1 ?? '',
            fullName: client.accountFullName ?? '',
            phoneId: client.phoneID?.toString() ?? undefined,
            phoneNumber: obtenerNumero(client.phoneNumber ?? ''),
            emailId: client.emailID ?? undefined,
            email: client.email ?? '',
            codePhoneNumber:
              client.phoneNumber != undefined
                ? obtenerCodigoArea(client.phoneNumber)
                : undefined,
            reset: false,
            accountSelected: {} as AccountInterface,
            ShipmentType:
              client.destinationAddressID !== null
                ? DeliveryEnum.DELIVERY
                : DeliveryEnum.OFFICE,
            displayName: client.displayName ?? '',
            reference: client.addressLandMark ?? '',
          },
        })

        let buWork = businessUnits.find(
          (x) => x.buCode === client.buCodeConsignee
        )
        if (
          client.destinationAddressID !== undefined &&
          buWork?.location !== undefined
        ) {
          buWork = {
            ...buWork,
            location: {
              ...buWork.location,
              name: client.addressName,
            },
          }
        }

        formik.setFieldValue('shippingLocation', buWork?.location)
        updateBusinessUnitSearch(
          buWork,
          client.destinationAddressID !== undefined
            ? client.addressLine1
            : undefined
        )
        setLoadingStatus(ConfirmModalStatus.SUCCESS)
        setLoading(false)
      } else {
        setLoadingStatus(ConfirmModalStatus.ERROR)
        setLoadingTitle('Error: ' + favoriteDestination?.errorMessage)
        setLoading(true)
      }
    }
    fetchShipments()
  }, [user?.client?.id])

  useEffect(() => {
    if (formik.values.consignee.reset) setselectDestination(false)
    else setselectDestination(true)
  }, [formik.values.consignee.reset])

  useEffect(() => {
    if (formik.values.consignee.businessUnit === undefined) {
      setBusinessUnitSearch('')
      setCitySearch('')
    }
  }, [formik.values.consignee.businessUnit])

  const updateBusinessUnitSearch = (
    businessUnit?: BusinessUnitInterface,
    Address?: string
  ) => {
    if (!!businessUnit) {
      const findBusiness = businessUnits.find(
        (x) => x.buCode === businessUnit.buCode
      )
      const fiendCities = cities.find(
        (c) => c.locationCode === findBusiness?.location?.locationCode
      )

      if (
        formik.values.consignee?.ShipmentType?.toString() ===
        DeliveryEnum.OFFICE?.toString()
      ) {
        formik.setFieldValue(
          'consignee.address',
          businessUnit?.location.address ?? ''
        )
      }

      if (Address !== undefined) {
        formik.setFieldValue('consignee.address', Address ?? '')
      }

      formik.setFieldValue(
        'consignee.cityCode',
        fiendCities?.locationCode ?? ''
      )
      formik.setFieldValue(
        'consignee.cityCode',
        fiendCities?.locationCode ?? ''
      )
      formik.setFieldValue('consignee.businessUnit', findBusiness)
      formik.setFieldValue('consignee.city', fiendCities?.locationName ?? '')
      setBusinessUnitSearch(
        findBusiness?.buCode + ' - ' + findBusiness?.location.name
      )
    } else {
      setBusinessUnitSearch('')
      setCitySearch('')
    }
  }

  const updateCitySearch = useCallback(() => {
    if (!!formik.values.consignee.city) {
      setCitySearch(formik.values.consignee.city)
    } else {
      setCitySearch('')
    }
  }, [formik.values.consignee.city])

  const getLocations = async () => {
    setFavoriteList([])
    setHistoricList([])

    const phonetype = await GeneralTypePhoneServices('236')
    if (!!phonetype.didError || !phonetype.model) return

    const emptyPhonePrefix = { value: 'FIJO', text: 'FIJO' }
    let phonetypeList = phonetype.model as unknown as GeneralTypeInterface[]
    phonetypeList.push(emptyPhonePrefix)

    setPhonePrefixList(
      (phonetypeList as unknown as GeneralTypeInterface[]).map(
        (phone) => phone.value
      )
    )
  }

  useEffect(() => {
    getLocations()
  }, [clientId])

  // Un favorito no puede guardarse contra una tienda que el contrato prohíbe:
  // si se guarda igual, revienta después al crear la guía.
  const { rows: contractDestinationRows, status: contractStatus } =
    useContractDestinationBUs(user.client?.agreementID)

  const { options: allowedBusinessUnits, restricted: destinationsRestricted } =
    useMemo(
      () =>
        resolveDestinationBusinessUnits(
          businessUnits,
          contractDestinationRows,
          new Date()
        ),
      [businessUnits, contractDestinationRows]
    )

  const contractLoading = contractStatus === 'loading'
  const contractLookupFailed = contractStatus === 'failed'

  const businessUnitOptions = useMemo(() => {
    const result = [...allowedBusinessUnits]

    result.sort((a, b) => {
      const tokens = businessUnitSearch.split(' ')

      const aMatch = tokens.some((token) => token === a.buCode)
      const bMatch = tokens.some((token) => token === b.buCode)

      if (aMatch && !bMatch) return -1
      if (!aMatch && bMatch) return 1
      return 0
    })

    return result
  }, [allowedBusinessUnits, businessUnitSearch])

  return (
    <div className="flex h-full flex-col gap-1">
      {formik.values.consignee.favoriteId === undefined && (
        <div>
          <AccountSearchFavoriteHistoric
            title=""
            hideFavAndShip={true}
            selected={formik.values.consignee.accountSelected}
            error={
              touched?.accountSelected && errors?.accountSelected
                ? errors?.accountSelected
                : undefined
            }
            placeholder="Buscar destinatario. Ingresa Identificacion, nombre o telefono"
            favoriteLocations={[]}
            historicLocations={[]}
            onSelectClient={async (client) => {
              setselectDestination(true)
              setDisabledIdentification(true)
              formik.setValues({
                ...formik.values,
                consignee: {
                  ...formik.values.consignee,
                  id: client.id,
                  abbreviationName: identificationTypes.find(
                    (t) => t.abbreviationName === client?.abreviationName
                  )!,
                  identificationNumber: client.identificationNumber,
                  address: '', //client.fiscalAddress ?? '',
                  fullName: client.accountFullName ?? '',
                  accountSelected: client,
                  reset: false,
                  phoneId: undefined,
                  phoneTypeId: client.listAccountPhone[0]?.phoneTypeId ?? '',
                  phoneNumber:
                    obtenerNumero(client.listAccountPhone[0]?.phoneNumber) ??
                    '',
                  emailId: undefined, //client.listAccountEmail[0]?.emailID ?? undefined,
                  email: client.listAccountEmail[0]?.email ?? '',
                  codePhoneNumber:
                    obtenerCodigoArea(
                      client.listAccountPhone[0]?.phoneNumber
                    ) ?? '',
                },
              })
              let buWork = businessUnits.find(
                (x) => x.buCode === client?.businessUnit?.buCode
              )

              formik.setFieldValue('shippingLocation', buWork?.location)
              updateBusinessUnitSearch(buWork ?? client?.businessUnit)
            }}
            onSelectDestination={async (destination) => {
              formik.setValues({
                ...formik.values,
                consignee: {
                  ...formik.values.consignee,
                  id: destination.id,
                  businessUnit: destination.businessUnit,
                  abbreviationName: identificationTypes.find(
                    (t) =>
                      t.abbreviationName ===
                      destination.account?.abbreviationName
                  )!,
                  identificationNumber:
                    destination.account.identificationNumber,
                  address: destination.location.address ?? '',
                  fullName: destination.account.accountFullName ?? '',
                  postalCode: destination.location.postalCode ?? '',
                  reset: false,

                  codePhoneNumber:
                    obtenerCodigoArea(
                      destination.account.listAccountPhone[0]?.phoneNumber
                    ) ?? '',
                  phoneNumber:
                    obtenerNumero(
                      destination.account.listAccountPhone[0]?.phoneNumber
                    ) ?? '',
                  email: destination.account.listAccountEmail[0]?.email ?? '',

                  accountSelected: destination.account,
                  emailId:
                    destination.account?.listAccountEmail[0]?.emailID ??
                    undefined,
                  phoneId:
                    destination.account.listAccountPhone[0]?.phoneID?.toString() ??
                    undefined,
                  phoneTypeId:
                    destination.account.listAccountPhone[0]?.phoneTypeId?.toString() ??
                    '',
                  ShipmentType: destination.isHomeDelivery
                    ? DeliveryEnum.DELIVERY
                    : DeliveryEnum.OFFICE,
                },
              })

              let buWork: BusinessUnitInterface | undefined
              if (!destination.isHomeDelivery) {
                buWork = businessUnits.find(
                  (bu) => bu.buCode === destination.businessUnit.buCode
                )!
              } else {
                buWork = await getBusinessUnitByTerritory(
                  destination.location.coordinates.lng,
                  destination.location.coordinates.lat
                ).then((response: any) => response.model!)
              }

              updateBusinessUnitSearch(
                buWork ?? destination.businessUnit,
                destination.store?.location?.address ?? undefined
              )
              setselectDestination(true)
              setDisabledIdentification(true)
            }}
            openCreationModal={() => {
              formik.setValues({
                ...formik.values,
                consignee: {
                  ...formik.values.consignee,
                  abbreviationName: identificationTypes.find(
                    (t) => t.abbreviationName === 'V-'
                  )!,
                  identificationNumber: '',
                  codePhoneNumber: '',
                  address: '',
                  fullName: '',
                  phoneNumber: '',
                  email: '',
                  businessUnit: undefined,
                  accountSelected: {} as AccountInterface,
                  reset: false,
                  id: undefined,
                },
              })
              setselectDestination(true)
              setDisabledIdentification(false)
            }}
          />
          <hr className="my-6" />
        </div>
      )}

      {selectDestination === true ||
      (formik.values.consignee.id !== undefined &&
        formik.values.consignee.id !== '') ? (
        <div>
          <div className="flex h-full flex-col gap-1 mt-1 pl-6 mb-3">
            <FormText
              id="consignee.displayName"
              name="consignee.displayName"
              label="Etiqueta/Nombre del favorito"
              value={formik.values.consignee.displayName}
              error={
                touched?.displayName && errors?.displayName
                  ? errors?.displayName
                  : undefined
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="!h-8"
              maxLength={150}
              labelClassname="!text-xs"
              labelContainerClassname="flex sm:!justify-end !w-40 flex items-center"
              containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-row"
              style={{ maxWidth: '100rem' }}
              helperText="Crea una etiqueta que te ayude a reconocer esta dirección entre varias del mismo destinatario. Ejemplo: 'Alfredo Casa'"
            />
          </div>
          <div className="flex h-full flex-col gap-1 mt-1 pl-6">
            <h4 className="text-sm text-main-500 gap-2 font-bold mt-1">
              Detalles del Destinatario:
            </h4>

            <FormText
              id="consignee.fullName"
              name="consignee.fullName"
              label="Nombre"
              value={formik.values.consignee.fullName}
              error={
                touched?.fullName && errors?.fullName
                  ? errors?.fullName
                  : undefined
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="!h-8 !mt-1"
              disabled={disabledIdentification}
              labelClassname="!text-xs"
              labelContainerClassname="flex sm:!justify-end sm:w-40"
              containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
            />

            <div className="flex sm:flex-row !mt-1">
              <div className="w-80">
                <FormSelect
                  autoComplete="off"
                  id="consignee.abbreviationName"
                  name="consignee.abbreviationName"
                  label="Tipo de documento"
                  selected={formik.values.consignee.abbreviationName}
                  options={identificationTypes}
                  error={
                    touched?.abbreviationName && errors?.abbreviationName
                      ? errors?.abbreviationName
                      : undefined
                  }
                  onBlur={formik.handleBlur}
                  className="!h-8 !text-xs " // Añadí !w-32 para un ancho fijo más pequeño
                  labelClassname="!text-xs"
                  labelContainerClassname="flex sm:!justify-end sm:w-40"
                  containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center  flex-col sm:flex-row"
                  optionString={(option) => option.abbreviationName.slice(0, 1)}
                  onSelectOption={(option) =>
                    formik.setFieldValue('consignee.abbreviationName', option)
                  }
                  disabled={disabledIdentification}
                />
              </div>
              <div className="w-64 flex-auto">
                <FormText
                  id="consignee.identificationNumber"
                  name="consignee.identificationNumber"
                  label="Nro. Documento"
                  value={formik.values.consignee.identificationNumber}
                  error={
                    touched?.identificationNumber &&
                    errors?.identificationNumber
                      ? errors?.identificationNumber
                      : undefined
                  }
                  onChange={(e) => {
                    let re: RegExp
                    if (
                      formik.values.consignee.abbreviationName
                        .abbreviationName !== 'P-'
                    ) {
                      re = /^[0-9\b]{0,10}$/
                    } else {
                      re = /^[a-zA-Z0-9\b]{0,10}$/
                    }

                    if (e.target.value === '' || re.test(e.target.value)) {
                      formik.handleChange(e)
                    }
                  }}
                  onBlur={formik.handleBlur}
                  className="!h-8"
                  labelClassname="!text-xs"
                  labelContainerClassname="flex sm:!justify-end sm:w-[7rem]"
                  containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
                  disabled={disabledIdentification}
                />
              </div>
            </div>
            <div className="flex sm:flex-row !mt-1">
              <div className="w-80">
                <FormSearch
                  id="consignee.codePhoneNumber"
                  name="consignee.codePhoneNumber"
                  label="Operadora"
                  value={phonePreSearch}
                  options={phonePrefixList}
                  unselect={!!formik.values.consignee.codePhoneNumber}
                  className="!h-8"
                  labelClassname="!text-xs"
                  labelContainerClassname="flex sm:!justify-end sm:w-40"
                  containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
                  error={
                    touched?.codePhoneNumber && errors?.codePhoneNumber
                      ? errors?.codePhoneNumber
                      : undefined
                  }
                  onBlur={(e) => {
                    // Usar un pequeño retraso para permitir la selección de la opción
                    setTimeout(() => {
                      if (
                        !e.relatedTarget ||
                        !e.relatedTarget.classList.contains('option-class')
                      ) {
                        formik.handleBlur(e)
                      }
                    }, 200) // Ajusta el tiempo según sea necesario
                  }}
                  onChange={(e) => setPhonePreSearch(e.target.value)}
                  onSelectOption={(option) =>
                    formik.setFieldValue('consignee.codePhoneNumber', option)
                  }
                  onChangeFocus={(focus) => !focus && updatePhoneSearch()}
                  style={{ maxWidth: '15rem' }}
                  onFilter={filterGeneral}
                  RenderOption={({ option }) => (
                    <GenericoOption text={option} />
                  )}
                />
              </div>
              <div className="w-64 flex-auto">
                <FormText
                  id="consignee.phoneNumber"
                  name="consignee.phoneNumber"
                  label="Teléfono"
                  value={formik.values.consignee.phoneNumber}
                  error={
                    touched?.phoneNumber && errors?.phoneNumber
                      ? errors?.phoneNumber
                      : undefined
                  }
                  onChange={(e) => {
                    let re: RegExp
                    re = /^[0-9\b]{0,10}$/
                    if (e.target.value === '' || re.test(e.target.value)) {
                      formik.handleChange(e)
                    }
                  }}
                  maxLength={
                    formik.values.consignee.codePhoneNumber !== 'FIJO' ? 7 : 10
                  }
                  onBlur={formik.handleBlur}
                  className="!h-8"
                  labelClassname="!text-xs"
                  labelContainerClassname="flex sm:!justify-end sm:w-[7rem]"
                  containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
                />
              </div>
            </div>

            <FormText
              id="consignee.email"
              name="consignee.email"
              label="Correo"
              value={formik.values.consignee.email}
              error={
                touched?.email && errors?.email ? errors?.email : undefined
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="!h-8 !mt-1"
              labelClassname="!text-xs"
              labelContainerClassname="flex sm:!justify-end sm:w-40"
              containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
            />
          </div>
          <hr className="mt-6 mb-3" />
          <div className="flex h-full flex-col gap-1 mt-1 pl-6">
            <h4 className="text-sm text-main-500 gap-2 font-bold mb-3 mt-1">
              Datos del Destino:
            </h4>
            <FormRadioGroup
              id="consignee.ShipmentType"
              name="consignee.ShipmentType"
              label="Tipo Entrega"
              selected={formik.values.consignee.ShipmentType}
              labelClassname="!text-xs flex sm:!justify-end sm:w-40"
              className="flex flex-1 sm:ml-0 sm:gap-5 sm:items-center flex-col sm:flex-row"
              wrapperClassName="flex !flex-row ml-4"
              optionsClassName="text-xs !ml-1"
              options={[
                { value: DeliveryEnum.OFFICE, name: 'Tienda' },
                { value: DeliveryEnum.DELIVERY, name: 'Domicilio' },
              ]}
              onSelectOption={(opt) => {
                formik.setFieldValue('consignee.ShipmentType', opt)
              }}
            />

            <div className="lex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row ">
              {formik.values.consignee?.ShipmentType?.toString() ===
                DeliveryEnum.DELIVERY?.toString() && (
                <div className="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row">
                  <div className="flex sm:!justify-end sm:w-40 !text-xs block text-sm font-bold leading-6 text-gray-700 truncate !text-xs">
                    Ubicación
                  </div>
                  <div className="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row ml-2">
                    <AddressSearch
                      stores={stores}
                      selected={formik.values.shippingLocation}
                      region={AutocompleteRegion.TEALCA}
                      error={
                        formik.touched?.shippingLocation &&
                        formik.errors?.shippingLocation
                          ? formik.errors?.shippingLocation
                          : undefined
                      }
                      setSelectedLocation={async (location, store) => {
                        let newstore = await getBusinessUnitByTerritory(
                          location.coordinates.lng,
                          location.coordinates.lat
                        ).then((response: any) => response.model!)

                        if (newstore == null) {
                          formik.setFieldError(
                            'businessUnit',
                            'Las coordenadas no tienen unidad de negocio valida, comuniquese con soporte'
                          )
                        }
                        const locationCode = businessUnits.find(
                          (bu) => bu.buCode === store?.buCode
                        )?.location.locationCode

                        const fiendCities = cities.find(
                          (c) => c.locationCode === locationCode
                        )

                        formik.setValues({
                          ...formik.values,
                          businessUnit: store,
                          shippingLocation: location,
                          consignee: {
                            ...formik.values.consignee,
                            businessUnit: store,
                            address: location.address ?? '',
                            cityCode: fiendCities?.locationCode ?? '',
                            city: fiendCities?.locationName ?? '',
                            postalCode: location.postalCode ?? '',
                          },
                        })

                        setBusinessUnitSearch(
                          store?.buCode + ' - ' + store?.location?.name
                        )
                      }}
                    />
                  </div>
                </div>
              )}

              {formik.values.consignee?.ShipmentType?.toString() ===
                DeliveryEnum.DELIVERY?.toString() && (
                <FormText
                  value={formik.values.consignee?.reference ?? ''}
                  id="consignee.reference"
                  name="consignee.reference"
                  label="Punto de Referencia"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="!h-8 !mt-1"
                  labelClassname="!text-xs"
                  labelContainerClassname="flex sm:!justify-end sm:w-40"
                  containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
                />
              )}
            </div>

            <FormSearch
              id="consignee.businessUnit"
              name="consignee.businessUnit"
              label={titleShipment}
              placeholder="Ingresa la tienda"
              value={businessUnitSearch}
              options={businessUnitOptions}
              unselect={!!(businessUnitSearch.length > 0 ? ' ' : undefined)}
              className="!h-8 !mt-1"
              // spinner oculta la lista mientras no sepamos si el contrato
              // restringe (FormSearch.tsx:100 y :135 van contra !spinner).
              spinner={contractLoading}
              disabled={
                formik.values.consignee?.ShipmentType?.toString() ===
                  DeliveryEnum.DELIVERY?.toString() ||
                contractLoading ||
                contractLookupFailed
              }
              labelClassname="!text-xs"
              labelContainerClassname="flex sm:!justify-end sm:w-40"
              containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
              error={
                touched?.businessUnit && errors?.businessUnit
                  ? errors?.businessUnit
                  : undefined
              }
              onBlur={(e) => {
                // Usar un pequeño retraso para permitir la selección de la opción
                setTimeout(() => {
                  if (
                    !e.relatedTarget ||
                    !e.relatedTarget.classList.contains('option-class')
                  ) {
                    formik.handleBlur(e)
                  }
                }, 200) // Ajusta el tiempo según sea necesario
              }}
              onChange={(e) => setBusinessUnitSearch(e.target.value)}
              onSelectOption={(buWork) => {
                if (buWork === null) return

                const locationCode = businessUnits.find(
                  (bu) => bu.buCode === buWork?.buCode
                )?.location.locationCode

                const fiendCities = cities.find(
                  (c) => c.locationCode === locationCode
                )

                formik.setValues({
                  ...formik.values,
                  businessUnit: buWork,
                  shippingLocation: buWork?.location,
                  consignee: {
                    ...formik.values.consignee,
                    businessUnit: buWork,
                    address: buWork?.location.address ?? '',
                    cityCode: fiendCities?.locationCode ?? '',
                    city: fiendCities?.locationName ?? '',
                    postalCode: buWork?.location.postalCode ?? '',
                  },
                })

                setBusinessUnitSearch(
                  buWork?.buCode + ' - ' + buWork?.location?.name
                )
              }}
              onFilter={filterBusinessUnit}
              RenderOption={({ option }) => <BusinessUnitOption {...option} />}
            />

            {contractLookupFailed && (
              <div className="flex sm:ml-40 sm:pl-8">
                <p className="rounded-lg border border-yellow-400 bg-yellow-100 p-2 text-xs text-yellow-700">
                  No pudimos cargar las tiendas de tu contrato. Recarga la
                  página antes de guardar este destino.
                </p>
              </div>
            )}

            {destinationsRestricted && !contractLookupFailed && (
              <div className="flex sm:ml-40 sm:pl-8">
                <p className="text-xs leading-4 text-gray-500">
                  Solo se muestran las tiendas de destino de tu contrato.
                </p>
              </div>
            )}

            <FormSearch
              id="consignee.city"
              name="consignee.city"
              label="Ciudad destino"
              value={citySearch}
              disabled={true}
              options={cities}
              unselect={!!formik.values.consignee.city}
              className="!h-8 !mt-1"
              labelClassname="!text-xs"
              labelContainerClassname="flex sm:!justify-end sm:w-40"
              containerClassname="flex flex-1 sm:ml-0 sm:gap-8 sm:items-center flex-col sm:flex-row"
              error={touched?.city && errors?.city ? errors?.city : undefined}
              onBlur={formik.handleBlur}
              onChange={(e) => setCitySearch(e.target.value)}
              onChangeFocus={(focus) => !focus && updateCitySearch()}
              onSelectOption={(option) => {
                formik.setValues({
                  ...formik.values,
                  consignee: {
                    ...formik.values.consignee,
                    cityCode: option?.locationCode ?? '',
                    city: option?.locationName ?? '',
                  },
                })
              }}
              onFilter={filterCity}
              RenderOption={({ option }) => <CityOption {...option} />}
            />
            <FormTextArea
              id="consignee.address"
              name="consignee.address"
              label="Dirección"
              value={formik.values.consignee.address}
              error={
                touched?.address && errors?.address
                  ? errors?.address
                  : undefined
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="!mt-1"
              labelClassname="!text-xs"
              labelContainerClassname="flex sm:!justify-end sm:w-40 sm:mt-2"
              containerClassname="flex flex-1 sm:ml-0 sm:gap-8 flex-col sm:flex-row"
              disabled={true}
            />
            <ModalLoading
              open={loading}
              title={loadingTitle}
              status={loadingStatus}
              setOpen={setLoading}
              onPrint={() => {}}
            />
          </div>
        </div>
      ) : (
        <div /* Este es el div 2 */ className="red2" />
      )}
    </div>
  )
}
